import {WorkrequestDetailsBase} from '../../shared/data-objects/workrequest-details-base';

export class WorkrequestLndBaseDetails extends WorkrequestDetailsBase {
  developmentName: string;
  numberOfLots: number;
  stage: string;
  spearReference: string;
  planOfSubdivisionNumber: string;
  lotNumber: string;
  unitNumber: string;
  streetNumber: string;
  streetName: string;
  streetType: number;
  streetSuffixType: number;
  suburb: string;
  postCode: string;

  private _subdivisionRequiredYes: boolean;
  private _subdivisionRequiredNo: boolean;


  constructor() {
    super();
    this.developmentName = '';
    this.numberOfLots = 0;
    this.stage = '';

    this.unitNumber = '';
    this.streetNumber = '';
    this.streetName = '';
    this.streetType = 0;
    this.streetSuffixType = 0;
    this.suburb = '';
    this.postCode = '';

    this.spearReference = '';
    this.planOfSubdivisionNumber = '';
  }

  toUpperCase() {
  }

  setDescriptionOfWork() {
  }

  get subdivisionRequiredYes(): boolean {
    return this._subdivisionRequiredYes;
  }

  set subdivisionRequiredYes(v: boolean) {
    this._subdivisionRequiredYes = v;
    if (v) {
      this._subdivisionRequiredNo = false;
    }
  }

  get subdivisionRequiredNo(): boolean {
    return this._subdivisionRequiredNo;
  }

  set subdivisionRequiredNo(v: boolean) {
    this._subdivisionRequiredNo = v;
    if (v) {
      this._subdivisionRequiredYes = false;
    }}
}



// WEBPACK FOOTER //
// ./src/app/create-application/lnd-w-form/workrequest-lnd-base-details.ts